import { useRef, useState } from 'react';

// Swiper
import { Navigation, Pagination } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';

// Icons
import { faChevronLeft, faChevronRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

// Images
import image1 from '../../assets/img/asian-woman-4975939-4159825 1.png';
import image2 from '../../assets/img/black-woman-4975941-4159827 1.png';
import image3 from '../../assets/img/western-man-4975942-4159828 1.png';
import image4 from '../../assets/img/20.png';

// Styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

import TestimonialCard from './reviewCard';
const testimonials = [
  {
    name: 'Mehdi',
    avatar: image3,
    text: `This app is a must-have for any aviation enthusiast. With over 2,000 aircraft, detailed specs, 3D models, and AR views, it feels like a complete aviation encyclopedia in your pocket. The interface is smooth and the content is incredibly comprehensive. Highly recommended!`,
  },
  {
    name: 'Jason',
    avatar: image4,
    text: `TopGun Aviation Academy is outstanding—beautiful 3D models, tons of aircraft details, and an easy-to-use interface. Perfect for aviation enthusiasts and learners alike. Highly recommended!`,
  },
  {
    name: 'Aviation Fan',
    avatar: image1,
    text: `TopGun Aviation Academy delivers an exceptional aviation experience with rich aircraft data, stunning visuals, and a polished, intuitive design. Exploring both modern jets and classic aircraft is a joy. A fantastic app for anyone passionate about aviation.`,
  },
  {
    name: 'Flight Enthusiast',
    avatar: image2,
    text: `TopGun Aviation Academy is an incredibly well-crafted app that combines education and exploration. The detailed aircraft specifications, interactive 3D models, and clean design make learning about aviation both engaging and enjoyable. It’s a perfect companion for aviation fans, students, and simulator pilots alike.`,
  },
];

export default function AppReviews() {
  const [init, setInit] = useState(false); // state برای re-render
  const reviewePrevRef = useRef(null);
  const revieweNextRef = useRef(null);

  return (
    <section className="reviews section">
      <div className="">
        <h2 className="section__title section__title-gradient">App Reviews</h2>

        <div className="swiper-container">
          <button
            ref={reviewePrevRef}
            className="products__btn products__btn--prev"
            type="button"
            aria-label="Previous review"
          >
            <FontAwesomeIcon icon={faChevronLeft} />
          </button>

          <Swiper
            modules={[Navigation, Pagination]}
            centeredSlides
            slidesPerView={3}
            loop={true}
            spaceBetween={100}
            pagination={{ clickable: true }}
            navigation={{
              prevEl: reviewePrevRef.current,
              nextEl: revieweNextRef.current,
            }}
            onInit={() => setInit(true)} // trigger re-render
            breakpoints={{
              0: { slidesPerView: 1, spaceBetween: 16 },
              768: { slidesPerView: 2, spaceBetween: 24 },
              1024: { slidesPerView: 3, spaceBetween: 30 },
            }}
          >
            {testimonials.map((item) => (
              <SwiperSlide key={item.name} className="testimonial-slide">
                <TestimonialCard {...item} />
              </SwiperSlide>
            ))}
          </Swiper>

          <button
            ref={revieweNextRef}
            className="products__btn products__btn--next"
            type="button"
            aria-label="Next review"
          >
            <FontAwesomeIcon icon={faChevronRight} />
          </button>
        </div>
      </div>
    </section>
  );
}
